<div class="relative">
  @let numberOfTickets = amount();
  @let name = ticketName();
  @let peopleCount = amountOfPeople();
  @let product = productDefinition();
  @let attributes = ticketAttributes();
  <div
    class="absolute top-0 right-0 flex h-8 w-8 cursor-pointer justify-center">
    <span
      tabindex="0"
      class="material-symbols-rounded"
      [attr.data-testid]="
        'shopping-cart-ticket-open-sub-menu' | appendTestId: name
      "
      (keydown.enter)="showSubMenu()"
      (click)="showSubMenu()">
      more_vert
    </span>
    <div class="relative">
      @if (isSubMenuVisible()) {
        <aw-direct-ticket-shopping-cart-sub-menu
          awCloseOnOffClick
          (onSubmenuClick)="handleSubMenuClick($event, positionInCart())"
          (onOffClick)="hideSubMenu()"
          class="absolute right-4 z-10"></aw-direct-ticket-shopping-cart-sub-menu>
      }
    </div>
  </div>

  <div
    class="text-2xl font-semibold"
    [attr.data-testid]="'shopping-cart-ticket-title' | appendTestId: name">
    @if (ticket()) {
      {{
        (ticket().texts | filterTexts: ERelationType.title | language) || name
      }}
    } @else {
      {{ name }}
    }
  </div>
  @if (product?.via) {
    <div
      class="pb-3"
      [attr.data-testid]="'shopping-cart-ticket-via' | appendTestId: name">
      <aw-via-list [via]="viaToArray(product)"></aw-via-list>
    </div>
  }
  <div class="flex flex-row flex-wrap gap-2 pb-2">
    @for (attribute of attributes; track attribute) {
      <aw-chip [id]="attribute + '-' + $index" [text]="attribute"></aw-chip>
    }
    @let personsText =
      textStore.texts()
        | filterTexts: ERelationType.persons : EEntityType.directTicket
        | language;
    @if (isGroupTicket() && peopleCount !== undefined) {
      <aw-chip
        id="amount-of-people"
        [text]="peopleCount + ' ' + personsText"></aw-chip>
    }
    @let dateString = travelDate() | date: DATE_FORMAT;
    @if (dateString) {
      <aw-chip id="date" [text]="dateString"></aw-chip>
    }
    @if (isTicketOwnerDataRequired()) {
      @for (o of owner().controls; track o; let index = $index) {
        @let firstName = o.getRawValue().firstName;
        @let lastName = o.getRawValue().lastName;
        @if (firstName && lastName) {
          <aw-chip
            [id]="'ticket-owner-' + firstName + '-' + index"
            [text]="firstName + ' ' + lastName"></aw-chip>
        }
      }
    }
    @if (isGroupTicket()) {
      @for (companion of companions(); track $index) {
        @if (companion.firstName && companion.lastName) {
          <aw-chip
            [id]="
              'ticket-companion-' +
              companion.firstName +
              '-' +
              companion.lastName
            "
            [text]="companion.firstName + ' ' + companion.lastName"></aw-chip>
        }
      }
    }
    @if (!isTicketOwnerDataRequired() || alteredOwners().length === 0) {
      @let personalData = personalDataForm.getRawValue();
      @if (personalData.firstName && personalData.lastName) {
        <aw-chip
          [id]="'ticket-owner-me'"
          [text]="
            personalData.firstName + ' ' + personalData.lastName
          "></aw-chip>
      }
    }
  </div>
  @if (product?.price?.priceIncludingVat) {
    <div class="flex flex-row items-center justify-between">
      <div
        [attr.data-testid]="'shopping-cart-ticket-amount' | appendTestId: name">
        {{
          textStore.texts()
            | filterTexts: ERelationType.amount : EEntityType.generic
            | language
        }}: {{ numberOfTickets }}
      </div>
      <div
        [attr.data-testid]="'shopping-cart-ticket-price' | appendTestId: name">
        {{
          (product!.price.priceIncludingVat | decimalsToCents) * numberOfTickets
            | centsToEuros
        }}
      </div>
    </div>
  }
</div>
